import styled from 'styled-components';
import sizes from 'utils/screenSizes';

export const Container = styled.div`
  height: 100%;
  width: 100%;

  @media all and (min-width: ${sizes.notebook}) {
    overflow: auto;
  }
`;

export const HeaderCommunication = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;

  padding: 50px 0;
`;

export const BodyContainer = styled.div`
  width: 100%;
  padding: 50px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const Image = styled.img`
  height: 80px;
  object-fit: contain;
`;

export const Body = styled.div`
  width: 50%;
  gap: 30px;
  background-color: rgb(255, 116, 0);
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;

  p {
    color: #fff;
    font-family: Arial, Helvetica, sans-serif;
    font-size: 26px;
    text-align: center;

    @media (max-width: ${sizes.notebook}) {
      font-size: 18px;
    }
  }

  @media (max-width: 768px) {
    width: 90%;
  }
`;

export const Footer = styled.div`
  width: 30vw;
  gap: 30px;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;

  h3 {
    color: #000;
    font-family: Arial, Helvetica, sans-serif;
    font-size: 20px;
    text-align: center;
  }

  h6 {
    color: #000;
    font-family: Arial, Helvetica, sans-serif;
    font-size: 18px;
    text-align: center;
    font-weight: 400;
  }

  @media (max-width: 768px) {
    width: 90%;
  }
`;
